import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CopyValueComponent } from './copy-value.component';
import { IconModule } from '@shared/modules/common/icon/icon.module';

@NgModule({
  declarations: [CopyValueComponent],
  imports: [CommonModule, IconModule],
  exports: [CopyValueComponent]
})
export class CopyValueModule {}
